export default __webpack_public_path__ + "62e1b98d76f734568be6dc87a457cb8a.svg";